module.exports = "li div.custom{background: url(\"/assets/ic_alert_icon.svg\") #f2dede no-repeat 8px center /18px auto; padding:5px 5px 5px 30px; }"


//////////////////
// WEBPACK FOOTER
// ./src/app/checkout/checkout.component.css
// module id = ./src/app/checkout/checkout.component.css
// module chunks = main